import React from 'react'
import html from '../assets/html.png'
import css from '../assets/css.png'
import github from '../assets/github.png'
// import icon from '../assets/icon.jpg'
// import graphql from '../assets/graphql.png'
import javascript from '../assets/javascript.png'
import react from '../assets/react.png'
import tailwind from '../assets/tailwind.png'
import node from '../assets/node.png'
import mongo from '../assets/mongo.png'





const Experience = () => {

    const techs = [ 
        { 
            id:1,
            src:html,
            title:'HTML', 
            style:'shadow-orange-500 '
        },
        { 
            id:2,
            src:css,
            title:'CSS', 
            style:'shadow-blue-500'
        }, 
        { 
            id:3,
            src:javascript,
            title:'Java Script', 
            style:'shadow-yellow-500'
        }, 
        { 
            id:4,
            src:node,
            title:'Node', 
            style:'shadow-green-500'
        }, 
        { 
            id:5,
            src:react,
            title:'React', 
            style:'shadow-blue-500'
        }, 
        { 
            id:6,
            src:tailwind,
            title:'Tailwind', 
            style:'shadow-sky-500'
        }, 
        { 
            id:7,
            src:mongo,
            title:'MongoDB', 
            style:'shadow-green-800'
        },
        { 
            id:8,
            src:github,
            title:'Github', 
            style:'shadow-gray-500'
        },
    ]
  return (


    <div name='experience' className='experience'>
    <div className='bg-gradient-to-b from-gray-800 to-black w-full lg:h-auto '> 
    

            <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white '>
                <div>
                    <p className='text-4xl font-bold border-b-4 inline p-2 border-gray-500 ' >Experience</p>
                    <p className='py-6 ' >These are the technologies I've worked with</p>
                </div>


                <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-8 text-center py-8 px-12 sm:px-0 '>

{ techs.map( ({id , style , src , title}) => (


<div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}>
                        <img src={src} alt=""  className='w-20 mx-auto ' />
                        <p className='mt-4 '>{title}</p>
                    </div>


))}
                    
                </div>
            </div >
    </div>
    </div>
  )
}

export default Experience
